/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EmbedRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  embeddingsRequest: components.EmbeddingsRequest;
};

/** @internal */
export const EmbedRequest$inboundSchema: z.ZodType<
  EmbedRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  EmbeddingsRequest: components.EmbeddingsRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "EmbeddingsRequest": "embeddingsRequest",
  });
});
/** @internal */
export type EmbedRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  EmbeddingsRequest: components.EmbeddingsRequest$Outbound;
};

/** @internal */
export const EmbedRequest$outboundSchema: z.ZodType<
  EmbedRequest$Outbound,
  z.ZodTypeDef,
  EmbedRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  embeddingsRequest: components.EmbeddingsRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    embeddingsRequest: "EmbeddingsRequest",
  });
});

export function embedRequestToJSON(embedRequest: EmbedRequest): string {
  return JSON.stringify(EmbedRequest$outboundSchema.parse(embedRequest));
}
export function embedRequestFromJSON(
  jsonString: string,
): SafeParseResult<EmbedRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EmbedRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EmbedRequest' from JSON`,
  );
}
